
export default function Testimonials() {
  return (
    <section className="py-32 bg-[#FDF8F6]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-16">
          <div className="w-[60%]">
            <p className="text-gray-500 text-sm mb-16 flex items-center gap-2">
              <span className="w-2 h-2 rounded-full bg-rose-400"></span>
              CUSTOMER REVIEWS
            </p>

            <div className="mb-8">
              <span className="text-rose-400 font-serif text-8xl leading-none">&ldquo;</span>
              <p className="font-serif text-[#2a2a2a] text-5xl font-medium leading-relaxed mt-4" style={{ lineHeight: '1.4' }}>
                Mount Zion Beauty Store completely transformed my makeup routine with their incredible product selection and expert advice
              </p>
            </div>

            <div className="flex items-center gap-3 mt-8">
              <div>
                <p className="font-bold text-lg text-gray-900">Emily Johnson</p>
                <div className="flex items-center gap-2 mt-1">
                  <i className="ri-verified-badge-fill text-rose-400 text-base"></i>
                  <span className="text-rose-400 text-sm">Verified Customer</span>
                </div>
                <div className="flex items-center gap-1 mt-2">
                  {[1,2,3,4,5].map(i => (
                    <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="w-[40%]">
            <div className="relative h-[600px] rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/7ecebad4b17ddbec305dcd76aa9b1a85.jpg"
                alt="Emily Johnson"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-rose-100/20 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}